import { useState } from "react";

// Assets
import ICheckRounded from "assets/i-check-rounded.js";
import IFullscreen from "assets/i-fullscreen.js";
import ISelectImg from "assets/i-select-img.gif";
import ILoaderImg from "assets/i-loader-img.gif";

import Button from "components/v1/Button";

const CardImage = ({ onOpenModalImages, isSelect, isDraft, isProcessing, isDisabled, onSelect, data }) => {
  const [isHover, setIsHover] = useState(false);
  const roundedClass = (isSelect || isProcessing) ? "rounded-[48px]" : "rounded-[8px]";

  return (
    <div
      onMouseEnter={() => !isDisabled && setIsHover(true)}
      onMouseLeave={() => !isDisabled && setIsHover(false)}
      aria-disabled={isDisabled}
      className="relative cursor-pointer h-fit"
    >
      <div
        className={`w-[184px] aspect-square ${roundedClass} ${isDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
      >
        <img
          src={data?.url}
          alt={data?.id || "Property"}
          className={`w-full h-full object-cover ${roundedClass}`}
        />
      </div>

      {isSelect && (
        <img
          src={ISelectImg}
          alt="selected img"
          className="w-[32px] aspect-square absolute z-30 -top-4 left-1/2 -translate-x-1/2"
        />
      )}

      {isDraft && (
        <div className="flex items-center gap-0.5 rounded-[2px] bg-[#ECF6F0] absolute z-30 -top-2 left-1/2 -translate-x-1/2 w-fit px-1 py-0.5">
          <ICheckRounded color="#3B9B60" />
          <p className="text-[11px] font-inter-bold leading-[15px] text-[#2D7649] whitespace-nowrap">
            Sudah dirapikan
          </p>
        </div>
      )}

      {isHover && (
        <div className="absolute z-20 top-0 left-0 rounded-[2px] w-full h-full bg-[rgba(4,7,4,0.2)] backdrop-blur-[2px] flex items-center justify-center gap-2">
          <Button
            className="!w-8 !h-8 !p-[10px]"
            type="secondary"
            size="s"
            icon={ICheckRounded}
            iconColor="#252526"
            onClick={onSelect}
          />
          <Button
            className="!w-8 !h-8 !p-[10px]"
            type="secondary"
            size="s"
            icon={IFullscreen}
            onClick={onOpenModalImages}
          />
        </div>
      )}
      {isProcessing && (
        <div className="rounded-[48px] absolute z-20 top-0 left-0 w-full h-full bg-[rgba(4,7,4,0.2)] backdrop-blur-[2px] flex flex-col items-center justify-center gap-2">
          <img
            src={ILoaderImg}
            alt="selected img"
            className="w-[32px] aspect-square"
          />
          <p className="text-[12px] font-inter-medium text-white">Sedang merapikan...</p>
        </div>
      )}
    </div>
  );
};

export default CardImage;
